module.exports = __webpack_public_path__ + "img/롯데카드.3c8dfad5.png";